import React from 'react'
import { useSelector } from 'react-redux'
import { currencyFormat, percentageFormat } from '../../core/helpers'

import OverviewMarketCap from './OverviewMarketCap'
import OverviewValueChange from './OverviewValueChange'

function OverviewGlobalMarkets() {
  const {
    points,
    marketCap,
    marketCapDiff24h,
    marketCapDefi,
    marketCapDefiDiff24h,
    volume24h,
    volume24hDiff,
    dominanceBTC,
    dominanceBTCDiff24h,
    totalValueLocked,
    totalValueLockedDiff24h
  } = useSelector(state => state.marketsGlobal)

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div>
        <OverviewMarketCap
          marketCap={marketCap}
          marketCapDiff24h={marketCapDiff24h}
        />
      </div>
      <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <OverviewValueChange
              title="Volume 24H"
              value={currencyFormat(volume24h)}
              change={volume24hDiff}
              points={points.volume}
              seeMoreLink="/volume"
            />
          </div>
          <div>
            <OverviewValueChange
              title="BTC Dominance"
              value={percentageFormat(dominanceBTC, { forceSign: false })}
              change={dominanceBTCDiff24h}
              points={points.dominance}
              seeMoreLink="/btc-dominance"
            />
          </div>
          <div>
            <OverviewValueChange
              title="DeFi Market Cap"
              value={currencyFormat(marketCapDefi)}
              change={marketCapDefiDiff24h}
              points={points.defiMarket}
              seeMoreLink="/defi-market-cap"
            />
          </div>
          <div>
            <OverviewValueChange
              title="TVL in DeFi"
              value={currencyFormat(totalValueLocked)}
              change={totalValueLockedDiff24h}
              points={points.tvl}
              seeMoreLink="/defi-tvl"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default OverviewGlobalMarkets
